import { useState, useEffect, useCallback } from 'react'
import api from '../../../services/api'

const useAiCreditData = () => {
  const [state, setState] = useState({
    data: null,
    loading: true,
    error: null
  })
  const [dateFrom, setDateFrom] = useState('')
  const [dateTo, setDateTo] = useState('')
  const [tableFilter, setTableFilter] = useState('All Time')

  const fetchData = useCallback(async () => {
    if (tableFilter === 'Other' && (!dateFrom || !dateTo)) {
      setState(prev => ({ ...prev, loading: false }))
      return
    }
    setState(prev => ({ ...prev, loading: true, error: null }))
    // Map time filter labels to API values
    const mapFilter = (label) => {
      switch (label) {
        case 'All Time': return 'allTime'
        case 'Today': return 'today'
        case 'This Week': return 'week'
        case 'This Month': return 'month'
        case 'This Year': return 'year'
        case 'Other': return 'other'
        default: return 'allTime'
      }
    }

    // Determine the date filter to send
    const selectedDateFilter = mapFilter(tableFilter)

    try {
      const response = await api.reports.getUsageReportCredits({
        date: selectedDateFilter,
        from: dateFrom,
        to: dateTo
      })

      const responseData = response?.data || response
      if (responseData?.status === 'error') {
        throw new Error(responseData?.message || 'Failed to fetch AI credit usage data')
      }

      const creditsData = responseData?.credits || {}

      // Map service_usage array to usageByFeature object
      const usageByFeature = {
        'ai-image': 0,
        'ai_video': 0,
        audio: 0,
        course: 0,
        podcast: 0,
        maze: 0,
        sharebot: 0
      }

      if (Array.isArray(creditsData.service_usage)) {
        creditsData.service_usage.forEach(item => {
          let mappedType = item.type
          if (item.type === 'image') mappedType = 'ai-image'
          if (item.type === 'video' || item.type === 'Ai_video' || item.type === 'ai_video') mappedType = 'ai_video'

          if (usageByFeature.hasOwnProperty(mappedType)) {
            usageByFeature[mappedType] = item.credits
          }
        })
      }

      const mergedData = {
        totalCredits: creditsData.total_credits || 0,
        usedCredits: creditsData.total_used || 0,
        remainingCredits: creditsData.remaining_credits || 0,
        consumedPercent: creditsData.consumed_percent,
        usageByFeature,
        serviceUsage: creditsData.service_usage || [],
        timelineData: creditsData.timeline_data || [],
        recentActivity: creditsData.recent_activity || []
      }

      setState({
        data: mergedData,
        loading: false,
        error: null
      })
    } catch (error) {
      console.error('Error fetching AI credit usage data:', error)
      setState({
        data: null,
        loading: false,
        error: error.message || 'Failed to fetch AI credit usage data'
      })
    }
  }, [tableFilter, dateFrom, dateTo])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return {
    ...state,
    tableFilter,
    setTableFilter,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    refetch: fetchData
  }
}

export default useAiCreditData

